/**
 * Relocates the hidden gift-info block rendered by sections/sb-gift-rules.liquid
 * (grouped by data-product-id) into the current product page's .sb-gift-slot
 * placeholder. Liquid already rendered all copy/pricing/translation for every
 * group — this only moves a DOM node, it never re-renders gift copy.
 */
(function () {
  'use strict';

  document.querySelectorAll('.sb-gift-slot').forEach(function (slot) {
    var productId = slot.dataset.productId;
    if (!productId) return;
    var group = document.querySelector('.sb-gift-group[data-product-id="' + productId + '"]');
    if (!group) return;
    group.hidden = false;
    slot.replaceWith(group);
  });
})();
